import { PageTable, Header } from "/src/layouts/page";
import ModalManager from "@ebay/nice-modal-react";
import NiceModal from "@ebay/nice-modal-react";

import ApiModal from "/src/components/modal/ApiModal/ApiModal";

import { useNavigate } from "react-router-dom";
import Table from "/src/components/table";
import "./PhoneTable.css";
import phoneService from "../../services/phoneService";
import PhoneModal from "../modal/PhoneModal";
import Storage from "/src/utils/storage";

import ImportPhonesModal from "../modal/ImportPhonesModal/ImportPhonesModal";
import capitalizeFirstLetter from "/src/utils/capitalizeFirstLetter";
import hasPermission from "/src/utils/hasPermission";
import formatPhoneNumber from "/src/utils/formatPhoneNumber";
import { switchCompany } from "/src/utils/switchCompany";
import { getStatusNameByValue} from '../../data/statusPhones';

function PhoneTable({ bare = false }) {
    const { getPhone, getPhones, deletePhone } = phoneService;
    const storage = Storage("local");
    const { is_admin } = storage.get("user");
    const navigate = useNavigate();

    const handleSwitch = async (id) => {
        await switchCompany(id, navigate);
    };

    var cells = [
        {
            column: "NUMBER",
            name: "numbers",
            sort: true,
            show: (value) => formatPhoneNumber(value),
        },
        {
            column: "DESCRIPTION",
            name: "libelle",
            show: (value) => value,
        },
        {
            column: "PARTNER",
            name: "telephony_partner",
            sort: true,
            show: (value) => value ?? "-",
        },
        {
            column: "OWNER",
            name: "number_owner",
            sort: true,
            show: (value) => value ?? "-",
        },
        {
            column: "JAMBONZ TRUNK",
            name: "jambonz_data.jambonz_trunk_name",
            sort: true,
            show: (value) => value ?? "-",
        },
        {
            column: "JAMBONZ ROUTING",
            name: "jambonz_data.jambonz_app_routing",
            sort: true,
            show: (value) => value ?? "-",
        },
        {
            column: "REFERENCE",
            name: "contact_reference",
            sort: true,
            show: (value) => value ?? "-",
        },
        {
            column: "STATUS",
            name: "status",
            sort: true,
            show: (value) => {
                if (value === "free") return <span className="phone_status_free">{getStatusNameByValue(value)}</span>;
                if (value === "production") return <span className="phone_status_production">{getStatusNameByValue(value)}</span>;
                return getStatusNameByValue(value);
            },
        },
        {
            column: "IN",
            name: "in",
            sort: true,
            show: (value) => value ? <i className="fa fa-check" aria-hidden="true" style={{ color: "var(--main)" }} /> : <span style={{ color: "var(--main)", fontWeight: "bolder" }}>X</span>
        },
        {
            column: "OUT",
            name: "out",
            sort: true,
            show: (value) => value ? <i className="fa fa-check" aria-hidden="true" style={{ color: "var(--main)" }} /> : <span style={{ color: "var(--main)", fontWeight: "bolder" }}>X</span>
        },
        
    ];

    if (is_admin) {
        cells = [
            ...cells,
            {
                column: "ORGANIZATIONS",
                name: ["company.logo", "company.name", "company.id"],
                show: ([logo, name, id]) => (
                    <img
                        srcSet={logo}
                        title={name}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleSwitch(id)}></img>
                ),
            },
            { column: "MAX_SIMULTANEOUS_CALL", name: "max_simultaneous_call", sort: true, show: (value) => value },
        ];
    }

    cells = [...cells, { column: "Channel", name: "channel.name", show: (value) => value }];

    const showAddModal = ({ addRow }) =>
        NiceModal.show(PhoneModal, {
            title: "Add a new Phone number",
        }).then((phone) => addRow(phone));

    const showEditModal = ({ updateRow, row }) =>
        NiceModal.show(PhoneModal, {
            title: "Modify Bot Telephony",
            data: { ...row },
        }).then((company) => updateRow(company));

    const onClickDelete = async ({ row, deleteRow }) => {
        const { id, numbers } = row;
        await ModalManager.show(ApiModal, {
            title: "Delete phone " + numbers,
            body: "Do you really want to delete phone " + numbers,
            api: {
                request: deletePhone,
                param: [id, numbers],
            },
            buttons: [
                { className: "validate", label: "Cancel", style: { marginRight: "20px" } },
                { className: "cancel", label: "Delete", type: "submit" },
            ],
        }).then(() => deleteRow(id));
    };

    const actions = [
        hasPermission("update_phone")
            ? { className: "fas fa-cog action-button edit_action", style: {}, onClick: showEditModal }
            : null,
        hasPermission("delete_phone")
            ? {
                  className: "fas fa-trash action-button delete_action",
                  style: {},
                  onClick: onClickDelete,
                  condition: "is_mutu",
                  condition_match: true,
              }
            : null,
    ].filter((action) => action);

    const showImportModal = () => NiceModal.show(ImportPhonesModal, { nameBot: name });

    const buttons = [
        hasPermission("import_phones") ? { icon: "fas fa-upload", onClick: showImportModal } : null,
        hasPermission("create_phone") ? { icon: "fas fa-plus", onClick: showAddModal } : null,
    ].filter((button) => button);

    const filters = [{ type: "input", placeholder: "terms", name: "numbers" }];

    const content = (
        <>
            <div className="entete-dataset">
                <div className="entete-dataset" style={{ width: "115px" }}></div>
            </div>

            <Table
                name="Phone"
                cells={cells}
                api={getPhones}
                actions={actions}
                buttons={buttons}
                filters={filters}></Table>
        </>
    );

    if (bare) {
        return content;
    }

    return (
        <PageTable>
            <Header title="Manage Phones"></Header>
            {content}
        </PageTable>
    );
}

export default PhoneTable;
